<template>
	<div>
		<div class="tw-text-[32px] tw-font-bold tw-mb-3">
			{{ $t('integrations.choose-usage') }}
		</div>

		<div class="tw-text-2xl tw-font-medium">
			{{ $t('integrations.choose-usage-desc') }}
		</div>
		<AppForm class="tw-mt-3 tw-flex tw-flex-col tw-gap-4" @submit="onSubmit">
			<div>
				<AppCheckbox
					v-model="form.usage"
					customClasses="tw-items-start"
					trueValue="whatsapp_e_commerce"
				>
					<template v-slot:label="{ toggle }">
						<div class="tw-flex tw-cursor-pointer tw-flex-col tw-ps-3" @click="toggle()">
							<div class="tw-font-medium tw-text-gray-700">
								{{ $t('integrations.whatsapp-ecommerce') }}
							</div>
							<div class="tw-text-gray-600">
								{{ $t('integrations.whatsapp-ecommerce-desc') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
			</div>

			<div>
				<AppCheckbox
					v-model="form.usage"
					customClasses="tw-items-start"
					trueValue="whatsapp_marketing"
				>
					<template v-slot:label="{ toggle }">
						<div class="tw-flex tw-cursor-pointer tw-flex-col tw-ps-3" @click="toggle()">
							<div class="tw-font-medium tw-text-gray-700">
								{{ $t('integrations.whatsapp-marketing') }}
							</div>
							<div class="tw-text-gray-600">
								{{ $t('integrations.whatsapp-marketing-desc') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
			</div>

			<div>
				<AppCheckbox
					v-model="form.usage"
					customClasses="tw-items-start"
					trueValue="whatsapp_crm"
				>
					<template v-slot:label="{ toggle }">
						<div class="tw-flex tw-cursor-pointer tw-flex-col tw-ps-3" @click="toggle()">
							<div class="tw-font-medium tw-text-gray-700">
								{{ $t('integrations.whatsapp-crm') }}
							</div>
							<div class="tw-text-gray-600">
								{{ $t('integrations.whatsapp-crm-desc') }}
							</div>
						</div>
					</template>
				</AppCheckbox>
			</div>

			<div class="tw-mt-3 tw-flex tw-items-center tw-gap-3">
				<AppButton
					:label="$t('integrations.next-step')"
					size="xl"
					class="tw-rounded-full"
					endIcon="assets/v2/image/icons/arrow-narrow-right.svg"
					:loading="loading"
				/>
			</div>
		</AppForm>
	</div>
</template>

<script setup>
import { ref } from 'vue';
import { useLinkMarketplaceStore } from '../../../../stores/link-marketplace';
import { WhatsAppMarketplace } from '@/v2/modules/integrations/entities/marketplaces/whatsapp.js';
import { Alert } from '@/v2/plugins/alert';
import { useI18n } from 'vue-i18n';

const linkMarketplaceStore = useLinkMarketplaceStore();
const loading = ref(false);
const { t } = useI18n();

const form = ref({
	usage: [],
});

const onSubmit = async () => {
    console.log("linkMarketplaceStore.marketplace.id",linkMarketplaceStore.linkedMarketplaceId);
    if(form.value.usage.length ===0 ){
        Alert.error(t('integrations.please-select-one-usage-at-least'));
        return;
    }

	loading.value = true;
	try {
		await WhatsAppMarketplace.saveWhatsAppUsage(linkMarketplaceStore.linkedMarketplaceId, form.value);
		await linkMarketplaceStore.refetchSteps();
	}
	finally {
        loading.value = false;
    }
};
</script>

<style lang="scss" scoped></style>
